import type { FaireProductEntity } from "../../entity_types/product";

export const p_u73aa7tb2m: FaireProductEntity = {
  token: "p_u73aa7tb2m",
  type: "product",
  name: "Gold Dainty Sunflower Shape Charm, Sku#Y925",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/249624ccf5861ea238e4e25a7ea7ceece9e5733e3ede7ac981ef78d1e52bb8f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88938e94787c626c777d20c732a786c39cf39134635c57bd7e0cccdeea47d621.jpeg",
    "https://cdn.faire.com/fastly/588d0a9560f13b4678bd59728e46cc6193538ea2d947b163f58832dd872cc246.jpeg",
    "https://cdn.faire.com/fastly/2e207fec7a55d019dfce94a74e1f6655142498b8b7e4a46ed5e7a5fab22f72e0.jpeg",
    "https://cdn.faire.com/fastly/a01550711c7be33bbcca39a1b5bf410a6607b263921ae77593de66d1b589be2c.jpeg",
  ],
  priceDollars: 2.66,
  description:
    "\nQty: 1pc pack\nMaterial: Gold Filled\nSize: 8mm\n\nDescription:\n\nSilver: Rhodium Plated\nGold: 18K Gold Filled\nBlack: Palladium Plated\nRose Gold: Palladium Plated over Brass\n\nUsage: For the bracelet, necklaces, or other crafts, jewelry making\n\nGold Filled, Rhodium-plated and Palladium-plated findings have a precious metal look. Exquisite craft and unique design, use it as necklaces, bracelets, or earring components.\n-----------------------------------------------------\nShip from the U.S.A in 1-2 business days.\n\n* Lead-Free & Cadmium Free & Nickel Free*\n\n*All sizes are approximate\n\n***Please Conv. me if you need a quantity discount. \n",
  tags: [],
  msrpDollars: 5.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:27.251Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
